import {Link, useLocation} from "react-router-dom";
import React from "react";
import {useContentContext} from "../utils/ContentProvider";

const NotFound = () => {
  const location = useLocation()
  const {translations} = useContentContext()

  return (
    <div className="flex min-h-full flex-col bg-white pt-16 pb-12">
      <div className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <p className="text-base font-semibold text-[#457d04]">404</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">{translations.notFound.title}</h1>
            <p className="mt-2 text-base text-gray-500">{translations.notFound.description}</p>
            <div className="mt-6">
              <Link
                to={`/${location.search}`}
                className="text-base font-medium text-[#457d04] hover:text-[#457d04] hover:underline">
                {translations.notFound.buttonTitle}
                <span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
